import { ChatPane } from './ChatPane';
import { useInventoryDrones, useInventoryUsers } from '@/lib/api/queries';

export function InventoryIntelligence() {
  const drones = useInventoryDrones().data ?? [];
  const users = useInventoryUsers().data ?? [];

  return (
    <ChatPane
      title="Inventory Intelligence"
      scopeLabel="Inventory"
      suggestions={["Which drones don't have an agent?", 'Who has manager role?']}
      initialMessage={`Inventory loaded: ${users.length} users, ${drones.length} aircraft. Ask about user roles, certifications, drone status, or agent configuration.`}
      send={async (q, _hist, onToken) => {
        const ql = q.toLowerCase();
        let answer = '';
        if (ql.includes('agent') && (ql.includes("don't") || ql.includes('without') || ql.includes('no '))) {
          const without = drones.filter((d) => !d.agent_deployed);
          answer = without.length === 0 ? 'All drones have agents deployed.' : `Drones without an agent: ${without.map((d) => d.drone_id).join(', ')}`;
        } else if (ql.includes('manager')) {
          const mgrs = users.filter((u) => u.roles.includes('Manager'));
          answer = `Manager role: ${mgrs.length === 0 ? 'no one' : mgrs.map((u) => u.full_name).join(', ')}.`;
        } else if (ql.includes('yaml')) {
          const missing = drones.filter((d) => !d.yaml_created);
          answer = missing.length === 0 ? 'All drones have YAML configured.' : `Drones missing YAML: ${missing.map((d) => d.drone_id).join(', ')}.`;
        } else {
          answer = `${users.length} users, ${drones.length} drones in inventory. Ask about agents, YAML status, or specific roles.`;
        }
        for (const word of answer.split(/(\s+)/)) {
          await new Promise((r) => setTimeout(r, 24));
          onToken(word);
        }
      }}
    />
  );
}
